<script>
import { Bar, mixins } from 'vue-chartjs';

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    options: { type: Object, default: () => ({}) },
  },
  computed: {
    chartOptions() {
      return {
        ...this.options
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};

</script>
